export default {
  name: 'TemplateInfoVacationPackage',
  props: {
    infoPack: {
      type: Object,
      default: null,
    },
  },
};
